import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucBoomerang: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M12.4999 2.77498C12.3416 2.77498 12.1832 2.83332 12.0582 2.95832L6.6249 8.39165C5.74157 9.27498 5.74157 10.725 6.6249 11.6083L12.0582 17.0417C12.2999 17.2833 12.6999 17.2833 12.9416 17.0417C13.1832 16.8 13.1832 16.4 12.9416 16.1583L7.50824 10.725C7.10824 10.325 7.10824 9.67498 7.50824 9.27498L12.9416 3.84165C13.1832 3.59998 13.1832 3.19998 12.9416 2.95832C12.8166 2.84165 12.6582 2.77498 12.4999 2.77498Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucBoomerang
